import React from 'react';
import { useLanguage } from '../../Providers/LanguageContext'
import SignUpButton from './SignUpButton';
import iMg1 from "../../images/ilustraciones soluciones industriales_CUIDADO DE LA SALUD 1.png";
import iMg2 from "../../images/ilustraciones soluciones industriales_CUIDADO DE LA SALUD 2.png";
import iMg3 from "../../images/love-heartbeat.png";
import AgricultureBanner from './AgricultureBanner';


const HealthCare = () => {
  const { language } = useLanguage();

  return (
    <div>
      <AgricultureBanner healthcare={true} />

      <section id='agriculture_sec' style={{
        background: '#0c2637',
        padding: '0px 0px 30px 0px'
      }}>
        <div className='container-fluid'>
          <div className='row mb-5'>
            <div className='col-md-5 col-12 m-auto agriculture_box'>
              {/* <div className='agriculture_head'>
                <h3 style={{ color: "#3fa9f5" }}>{language.health_care}</h3>
                <p style={{ color: "#3fa9f5" }}>{language.fisi_help_improve_health}</p>
              </div> */}

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", fontSize: '38px', fontWeight: '700' }}>{language.automated_expence_track}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.healthcare_prof_often}</p>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_auto_expance_track}</p>
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg1} className='img-fluid' alt='' />
              </div>
            </div>
          </div>

          <div className='row row_reverse'>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg2} className='img-fluid' alt='' />
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto agriculture_box'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: '#000', fontSize: '38px', fontWeight: '700' }}>{language.busi_and_personal}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.healthcare_Prof_web}</p>
              </div>
            </div>
          </div>

          <div className='row mb-5' style={{
            marginTop: '110px'
          }}>
            <div className='col-md-5 col-12 agriculture_box m-auto'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: '#000', fontSize: '38px', fontWeight: '700' }}>{language.tax_prep_reporting}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.fisi_simplify_tax_pprep}</p>
              </div>


              <div className='agriculture_headtext'>
                <h4 style={{ color: '#000', fontSize: '38px', fontWeight: '700', textAlign: 'right' }}>{language.invoicing_and_payment}</h4>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.health_proff_bill}</p>
                <p style={{
                  color: '#000',
                  fontSize: '20px'
                }}>{language.app_create_and_send}</p>
              </div>
            </div>

            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg3} className='img-fluid' alt='' style={{ opacity: "0.5" }} />

                {/* <div className='registrarAnddescargar' style={{ transform: "translate(-50% , -50%)", top: "85%", }}>
                  <button className='registrar_Btn'>Registrarse</button>
                  <button className='descargar_Btn'>Descargar</button>
                </div> */}

              </div>
              <div className='mt-4'>
                <SignUpButton />
              </div>

            </div>
          </div>

          {/* <div className='row'>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#3fa9f5", textAlign: "left" }}>{language.invoicing_and_payment}</h4>
                <p>{language.health_proff_bill}</p>
                <p>{language.app_create_and_send}</p>
              </div>
            </div>

            <div className='col-md-6 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg3} className='img-fluid' alt='' style={{opacity: "0.5"}} />

                <SignUpButton/>
              </div>
            </div>
          </div> */}
        </div>
      </section>

    </div>
  )
}

export default HealthCare